import { render } from "./TheFooter.vue?vue&type=template&id=0adb9f0a&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=0adb9f0a&scoped=true&lang=css"

import exportComponent from "/Users/josecisneros/Desktop/Jose-Cisneros/Portfolio-Site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adb9f0a"]])

export default __exports__